export default __webpack_public_path__ + "static/media/com-gigi.184a54b7.mp4";